import { cva, type VariantProps } from 'class-variance-authority';
import styles from './field.module.css';

export const fieldVariants = cva(styles.field, {
  variants: {
    columns: {
      twelve: styles['columnsTwelve'],
      nine: styles['columnsNine'],
      eight: styles['columnsEight'],
      six: styles['columnsSix'],
      four: styles['columnsFour'],
      three: styles['columnsThree'],
    },
    maxWidthByChars: {
      twenty: styles['maxWidthByCharsTwenty'],
      ten: styles['maxWidthByCharsTen'],
      five: styles['maxWidthByCharsFive'],
      four: styles['maxWidthByCharsFour'],
      three: styles['maxWidthByCharsThree'],
      two: styles['maxWidthByCharsTwo'],
      one: styles['maxWidthByCharsOne'],
    },
    hasStartIcon: {
      true: '',
      false: '',
    },
    hasEndIcon: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    // For single icon
    {
      maxWidthByChars: 'twenty',
      hasStartIcon: true,
      class: styles['maxWidthByCharsTwentyWithIcon'],
    },
    {
      maxWidthByChars: 'ten',
      hasStartIcon: true,
      class: styles['maxWidthByCharsTenWithIcon'],
    },
    {
      maxWidthByChars: 'five',
      hasStartIcon: true,
      class: styles['maxWidthByCharsFiveWithIcon'],
    },
    {
      maxWidthByChars: 'four',
      hasStartIcon: true,
      class: styles['maxWidthByCharsFourWithIcon'],
    },
    {
      maxWidthByChars: 'three',
      hasStartIcon: true,
      class: styles['maxWidthByCharsThreeWithIcon'],
    },
    {
      maxWidthByChars: 'two',
      hasStartIcon: true,
      class: styles['maxWidthByCharsTwoWithIcon'],
    },
    {
      maxWidthByChars: 'one',
      hasStartIcon: true,
      class: styles['maxWidthByCharsOneWithIcon'],
    },
    {
      maxWidthByChars: 'twenty',
      hasEndIcon: true,
      class: styles['maxWidthByCharsTwentyWithIcon'],
    },
    {
      maxWidthByChars: 'ten',
      hasEndIcon: true,
      class: styles['maxWidthByCharsTenWithIcon'],
    },
    {
      maxWidthByChars: 'five',
      hasEndIcon: true,
      class: styles['maxWidthByCharsFiveWithIcon'],
    },
    {
      maxWidthByChars: 'four',
      hasEndIcon: true,
      class: styles['maxWidthByCharsFourWithIcon'],
    },
    {
      maxWidthByChars: 'three',
      hasEndIcon: true,
      class: styles['maxWidthByCharsThreeWithIcon'],
    },
    {
      maxWidthByChars: 'two',
      hasEndIcon: true,
      class: styles['maxWidthByCharsTwoWithIcon'],
    },
    {
      maxWidthByChars: 'one',
      hasEndIcon: true,
      class: styles['maxWidthByCharsOneWithIcon'],
    },

    // For both icons
    {
      maxWidthByChars: 'twenty',
      hasEndIcon: true,
      class: styles['maxWidthByCharsTwentyWithBothIcons'],
    },
    {
      maxWidthByChars: 'ten',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsTenWithBothIcons'],
    },
    {
      maxWidthByChars: 'five',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsFiveWithBothIcons'],
    },
    {
      maxWidthByChars: 'four',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsFourWithBothIcons'],
    },
    {
      maxWidthByChars: 'three',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsThreeWithBothIcons'],
    },
    {
      maxWidthByChars: 'two',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsTwoWithBothIcons'],
    },
    {
      maxWidthByChars: 'one',
      hasEndIcon: true,
      hasStartIcon: true,
      class: styles['maxWidthByCharsOneWithBothIcons'],
    },
  ],
  defaultVariants: {
    columns: 'twelve',
    hasStartIcon: false,
    hasEndIcon: false,
  },
});

export type FieldVariants = VariantProps<typeof fieldVariants>;
